import { Command } from "./index";
import { Icon } from "@chakra-ui/react";
import { MdCircle } from "react-icons/md";
import { insertSurroundingText } from "../utils/insertSurroundingText";
import { convertGameMakerColourToHex } from "../../../utils/convertGameMakerColourToHex";

export const colourCyan: Command = {
  category: "colour",
  icon: <Icon as={MdCircle} />,
  name: `#${convertGameMakerColourToHex(16776960)}`,
  tooltip: "colour as cyan",
  execute: (editorRef) => insertSurroundingText(editorRef, "{{#colourCyan}}", "{{/colourCyan}}"),
};
